import type { WorkflowState } from "./types"

/**
 * Create initial workflow state
 */
export const createInitialState = (): WorkflowState => ({
  isInitialized: false,
  flow: null,
  hoveredTrunkSourceId: null,
  realtimeSyncPaused: false,
  history: { past: [], future: [] },
  autoSave: {
    isSaving: false,
    isRefreshing: false,
    lastSavedAt: null,
    lastServerUpdatedAt: null,
    hasUnsavedChanges: false,
    error: null,
    conflictState: null
  }
})
